import {
  LAYOUTS,
  MENU_SECTIONS,
  MODULE_SETTINGS,
  USER_ROLES,
} from "shared/constants";
import type { AppRouteRecordRaw } from "shared/types";
import { STUDENT_MEETING_ROUTE_NAMES } from "./routeNames";

const routes: AppRouteRecordRaw[] = [
  {
    path: "/my-feedback",
    name: STUDENT_MEETING_ROUTE_NAMES.MY_FEEDBACK,
    component: () => import("meetings/student/pages/StudentMyFeedbackPage.vue"),
    meta: {
      title: "Mijn feedback",
      layout: LAYOUTS.MAIN_NO_WRAPPER,
      exactRouteIdentifier: STUDENT_MEETING_ROUTE_NAMES.MY_FEEDBACK,
      roleRequired: [USER_ROLES.STUDENT],
      settingRequired: [MODULE_SETTINGS.STUDENT_MEETING],
      isMenuItem: true,
      menuSection: MENU_SECTIONS.MAIN,
      menuOrder: 7,
      icon: "/images/menu/feedback.svg",
      studentView: true,
      hideTitle: true,
    },
  },
  {
    path: "/my-feedback/:id",
    name: STUDENT_MEETING_ROUTE_NAMES.MY_FEEDBACK_DETAIL,
    component: () =>
      import("meetings/student/pages/StudentMeetingDetailPage.vue"),
    meta: {
      title: "Mijn feedback",
      layout: LAYOUTS.MAIN_NO_WRAPPER,
      exactRouteIdentifier: STUDENT_MEETING_ROUTE_NAMES.MY_FEEDBACK,
      roleRequired: [USER_ROLES.STUDENT],
      settingRequired: [MODULE_SETTINGS.STUDENT_MEETING],
      studentView: true,
      hideTitle: true,
    },
  },
  {
    path: "/my-feedback/transition/:id",
    name: STUDENT_MEETING_ROUTE_NAMES.MY_FEEDBACK_TRANSITION_DETAIL,
    component: () =>
      import("meetings/student/pages/StudentTransitionMeetingDetailPage.vue"),
    meta: {
      title: "Mijn feedback",
      layout: LAYOUTS.MAIN_NO_WRAPPER,
      exactRouteIdentifier: STUDENT_MEETING_ROUTE_NAMES.MY_FEEDBACK,
      roleRequired: [USER_ROLES.STUDENT],
      settingRequired: [MODULE_SETTINGS.STUDENT_MEETING],
      studentView: true,
      hideTitle: true,
    },
  },
];

export default routes;
